<template>
  <div class="page--not-found">
    <div class="container-notfound">
      <img src="/assets/img/icons/404.png" class="icons" alt="SOCO" />
      <h2 class="heading">Kamar 404</h2>
      <p class="copywriting hidden-xs hidden-sm">
        Jangan panik, Anda memang sedang berada di antah berantah karena mencari sesuatu yang tidak tersedia di sini.<br /><br />
        Anda tetap bisa kembali dengan selamat untuk lanjut menjelajah.
      </p>
      <p class="copywriting hidden-lg hidden-md">
        Jangan panik, Anda memang sedang berada di antah berantah karena mencari sesuatu yang tidak tersedia di sini.
        Anda tetap bisa kembali dengan selamat untuk lanjut menjelajah.
      </p>

      <router-link class="btn-back-to-home" to="/">Kembali ke home</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-not-found',
  created() {
    window.prerenderReady = true;
  },
};
</script>
